module.exports = "https://static.cdns.space/tarot-temp/img/death.d6c27fe6.webp";